enum ContactLastActivityType {
  sms = "sms",
  whatsapp = "whatsapp",
}

export const contactLastActivityTypeAsString = (
  contactLastActivityType: ContactLastActivityType
): string => {
  switch (contactLastActivityType) {
    case ContactLastActivityType.sms:
      return "SMS";
    case ContactLastActivityType.whatsapp:
      return "WhatsApp";
    default:
      return "";
  }
};

export default ContactLastActivityType;
